module.exports = __webpack_public_path__ + "img/DA-HMI-Insurance-Tagging-2.29caebf4.webp";